import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import image from '../images/pp-vol1.jpg';
import pdf from '../pdfs/flyerbinary.pdf'; 
import { Helmet } from 'react-helmet';

function LeibnizOnBinary() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function scrollToElement(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        <a href="https://global.oup.com/academic/product/leibniz-philosophical-papers-16771686-9780198959786" target="_blank" rel="noopener noreferrer">Order from the publisher (Oxford University Press)</a><br /><br />
        <a href="https://www.amazon.co.uk/Leibniz-Philosophical-IUniversal-Characteristic-Encyclopaedia/dp/0198959788/" target="_blank" rel="noopener noreferrer">Order from Amazon (UK)</a><br /><br />
        <a href="https://www.amazon.com/Leibniz-Philosophical-1677-1686-Characteristic-Encyclopaedia/dp/0198959788/" target="_blank" rel="noopener noreferrer">Order from Amazon (US)</a><br /><br />
      </div>
    );
  }

  function endorsements() {
    return (
      <>
      <p>Endorsements:</p>
      
      </>
    );
  }
  
  return (
    <div>
       <Helmet>
            <title>Leibniz: Philosophical Papers 1677-1686: Universal Language, Characteristic, Logic, Encyclopaedia, and General Science</title>
            <meta name="description" content="A book authored by Lloyd Strickland on 'Philosophical Papers 1677-1686: Universal Language, Characteristic, Logic, Encyclopaedia, and General Science'" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()} <hr className="centered-hr" />
                    {endorsements()}
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: PHILOSOPHICAL PAPERS 1677-1686: UNIVERSAL LANGUAGE, CHARACTERISTIC, LOGIC, ENCYCLOPAEDIA, AND GENERAL SCIENCE</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}
                    <p>View endorsements <span style={{color: 'blue'}} onClick={() => scrollToElement('endorsements')}>here</span></p>
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                  <img src={image} alt="Philosophical Papers 1677-1686: Universal Language, Characteristic, Logic, Encyclopaedia, and General Science" style={{ float: 'left', marginRight: '20px', height: isMobile ? '220px' : '364px', width: 'auto' }} />
                  <p style={{ margin: '10px 0px 0px 0px', fontSize: '13px' }}>Published 30 April 2026, by Oxford University Press.</p><br />
                  <p>From the back cover blurb:</p>
                  This volume brings together 124 of Leibniz's writings on some of his most distinctive and ambitious projects including developing a new logic or art of discovery as a tool for uncovering new truths; creating a universal language with a rational, philosophical grammar structured to reflect human reasoning; designing a symbolic script (the characteristic) to facilitate discoveries across all fields of knowledge; planning an encyclopaedia in which existing knowledge would be systematically arranged to yield new insights; and advancing his vision of a collaborative, higher­ order science (the General Science) that would encompass the foundational principles of all other sciences.<br /><br />

The writings in this volume trace the evolution and interconnection of these projects during Leibniz's formative first decade in Hanover (1677-1686), and is the most extensive collection of such writings in English to date. Strickland has returned to Leibniz's original manuscripts to produce accurate, carefully annotated translations that document textual variations, deletions, and marginalia. Of the 124 texts included, 86 appear here in English for the first time, while five have never been published in any language.<br /><br />

In addition to the translations, the volume features a substantial introductory essay on Leibniz's life, work, and writings on a universal language, the characteristic, logic, the encyclopaedia, and general science from 1677 to 1686, along with detailed explanatory notes on each text, providing context, background, and the rationale for their dating.<br />
                  <br clear = "all" />
                  <b>TABLE OF CONTENTS</b><br /><br />
                  Abbreviations<br /><br />
                  Introduction<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. Leibniz's Life 1677-1686<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. Leibniz's Writings 1677-1686<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3. Overview: Logic, Universal Language, Characteristic, General Science and Encyclopaedia 1677-1686<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4. About the Volumes, Selections of Texts, Apparatus and Typographical Conventions<br /><br />
<b>Logic, Universal Language, Characteristic</b><br /><br />
<ol><li>After So Many Logics, The Logic I Want Has Not Yet Been Written (1677-1678 (?))</li>
<li>Definition (summer 1677 (?))</li>
<li>Empirical Notions (summer 1677 (?))</li>
<li>On the Natural Origin of Languages (second half of 1677 - first half of 1678 (?))</li>
<li>A Dialogue (August 1677)</li>
<li>Words (1678-1684 (?))</li>
<li>Didactic Method (early 1678 (?))</li>
<li>On Teaching Languages (early 1678 (?))</li>
<li>General Language (February 1678)</li>
<li>Universal Language (February 1678 (?))</li>
<li>Chrysippus' Heap (March 1678)</li>
<li>On a Rational Grammar and the Art of Memory (April 1678)</li>
<li>Paradoxes (summer 1678 - winter 1680/1681 (?))</li>
<li>Rational Language (autumn 1678 (?))</li>
<li>On Estimating the Uncertain (September 1678)</li>
<li>Analysis of Languages (11/21 September 1678)</li>
<li>Logical-Grammatical Notes (October - November 1678 (?))</li>
<li>Grammatical Thoughts (October - November 1678 (?))</li>
<li>Tables. Divisions. Method. Genera and Subaltern Species (November 1678)</li>
<li>On the Logical Characteristic (end of 1678 - March 1679 (?))</li>
<li>Primitive Propositions (winter 1678/1679 (?))</li>
<li>On a General Analytical Calculus (winter 1678/1679 (?))</li>
<li>On Principles (1679-1685 (?))</li>
<li>Elements for Building a Calculus (early 1679 (?))</li>
<li>Through the Characteristic, We Can Set Up Experiments in Metaphysics (first half of 1679 (?))</li>
<li>Logical Conversion (before spring 1679 (?))</li>
<li>What is Prior by Nature (spring-summer 1679 (?))</li>
<li>On Negation (spring 1679 - autumn 1685 (?))</li>
<li>My Characteristic Requires a New Encyclopaedia (March - April 1679 (?))</li>
<li>Elements of a Universal Characteristic (April 1679)</li>
<li>Elements of a Calculus (April 1679)</li>
<li>Elements of a Universal Calculus (April 1679)</li>
<li>Investigations for a Universal Calculus (April 1679)</li>
<li>A Calculus of Inferences (April 1679)</li>
<li>A Method of Examining Inferences by Numbers (April 1679)</li>
<li>Rules for the Validity of Inferences (April 1679)</li>
<li>Rules from which the Validity of Inferences and the Forms and Moods of Categorical Syllogisms Can Be Judged <var>by Means of Numbers</var> (April 1679)</li>
<li>Characteristic Numbers Expressed in Latin, Greek, and Hebrew (April 1679)</li>
<li>On the Universal Characteristic Language and the Art of Discovery (April - May 1679 (?))</li>
<li>Reasoning Calculus, or, the Art of Reasoning Easily and Infallibly (April - June 1679 (?))</li>
<li>Specimen of the Universal Calculus (April - June 1679 (?))</li>
<li>Addenda to Specimen of the Universal Calculus (April - June 1679 (?))</li>
<li>Verbal Characteristic (May - June 1679 (?))</li>
<li>Whether Ideas Have Parts (early August 1679 (?))</li>
<li>Characteristic (late 1679 - early 1680 (?))</li>
<li>Giving a Specimen of the Philosophical Language in Geometry (January 1680)</li>
<li>On Primary and Secondary Syllogistic Moods (May 1682 - December 1684 (?))</li>
<li>On Mathematically Determining the Forms of Syllogisms (May 1682 - December 1684 (?))</li>
<li>On the Demonstration of Non-identical Axioms (May 1682 - December 1684 (?))</li>
<li>Method of Disputing Until the Subject Is Exhausted (summer 1683 - winter 1685/1686 (?))</li>
<li>On Overcoming an Opponent Quickly (summer 1683 - winter 1685/1686 (?))</li>
<li>A Thread for Thinking, or, on Founding a New Logic (spring-summer 1684 (?))</li>
<li>The Synthetic Method, That Is, the Art of Ordering Theorems and Problems (1685 - October 1686 (?))</li>
<li>On the Rational Language (autumn 1685 (?))</li>
<li>On True and False, Affirmation and Negation, and Contradictories (summer-autumn 1686 (?))</li>
<li>General Investigations Concerning the Analysis of Notions and Truths (autumn 1686 (?))</li>
<li>Specimens of the Rational Calculus (autumn 1686 (?))</li>
<li>Demonstration of the Axioms of Identity and Diversity (autumn 1686 (?))</li>
<li>Definitions: Alike, Similar, Species, Affection (autumn 1686 (?))</li>
<li>A Calculus of Coincidents (autumn 1686 (?))</li>
<li>The Composition of One Thing by Another (autumn 1686 - early 1687 (?))</li>
<li>Specimen of a Calculus of Coincidents and Inexistents (autumn 1686 - early 1687 (?))</li>
<li>Grammatical Analysis for Creating a General Characteristic or Language (autumn 1686 - early 1687 (?))</li>
<li>Principles of Human Knowledge (autumn 1686 - early 1687 (?))</li>
<li>On the Principles of Contradiction and That There Is Nothing without a Reason (autumn 1686 - early 1687 (?))</li></ol>
<br />
<b>General Science and Encyclopaedia 1677–1686</b><br /><br />
<ol start="66">
<li>The True Method (autumn 1677 (?))</li>
<li>Deleted Remarks on Methods (summer-autumn 1678 (?))</li>
<li>On the Art of Discovery in General (summer-autumn 1678 (?))</li>
<li>On the Most Excellent Use of the Combinatorial Art, Which Is to Write an Encyclopaedia (summer-autumn 1678 (?))</li>
<li>Two Methods of Geometry (second half of 1678 (?))</li>
<li>Universal Atlas (second half of 1678 (?))</li>
<li>A Society or Order of Charity (autumn 1678)</li>
<li>Society of the Friends of God for Celebrating God's Praises and in Opposition to the Atheism Spreading throughout the World (autumn 1678)</li>
<li>On the Organon or Great Art of Thinking (August 1678 - April 1679 (?))</li>
<li>On the Alphabet of Human Thoughts (August 1678 - April 1679 (?))</li>
<li>Definitions: Something, Nothing, Substance (spring-summer 1679 (?))</li>
<li>A Plan for a New Encyclopaedia to Be Written Using the Method of Discovery (15/25 June 1679)</li>
<li>On the Combinatorial Art of Discovery (summer 1679 (?))</li>
<li>The Art of Mathematics (summer 1679 (?))</li>
<li>Preface for <var>The Key to Secret Mathematics</var> (summer 1679 (?))</li>
<li>On the Synthetic and Analytic Methods (summer 1679 (?))</li>
<li>On the Usefulness of the Analytic and Synthetic Methods (summer 1679 (?))</li>
<li>Combinatorics (summer 1679 (?))</li>
<li>Elements of Mathesis for the Use of Beginners (summer 1679 - April 1680 (?))</li>
<li>On the Characteristic Art and Analytical or Combinatorial Discoveries in Universal Mathesis (summer 1679 - April 1680 (?))</li>
<li>Definitions: Good, Perfect, Privative (1680 (?))</li>
<li>Formulas for Commands in All the Mechanical Arts Following the Example of Military Commands Concerning the Handling of Arms and Evolutions (1680-1685 (?))</li>
<li>Reduction of the Sciences to Figures and Formulas (1680-1685 (?))</li>
<li>Precognita to the Encyclopaedia, That Is, to Universal Science (first quarter of 1680 (?))</li>
<li>Directing Studies to Happiness (first quarter of 1680 (?))</li>
<li>Foundations and Specimens of the General Science Concerning a New System for the Renewal and Enhancement of the Sciences (first quarter of 1680 (?))</li>
<li>Foundations and Specimens of the General Science Concerning the Renewal and Enhancement of the Sciences (first quarter of 1680 (?))</li>
<li>Foundations of the General Science (first quarter of 1680 (?))</li>
<li>Preface for <var>Foundations of the General Science</var> (first quarter of 1680 (?))</li>
<li>Introduction to the General Science (first quarter of 1680 (?))</li>
<li>On the Notions That Form the Basis of Everything We Think About (second half of 1680 (?))</li>
<li>On the Literary Republic (first half of May 1681)</li>
<li>On Joining the Advances of the Ancients with Ours (summer 1681 - spring 1682 (?))</li>
<li>Preface for a Work on the Renewal of the Sciences (spring 1682 (?))</li>
<li>On the Elements of Truth (spring 1682 (?))</li>
<li>Mathematical Reflection on the Transformation of Bodies (spring 1682 (?))</li>
<li>Synopsis of <var>Foundations and Specimens of the New General Science</var> (spring-autumn 1682 (?))</li>
<li>Foundations and Specimens of the General Science (spring-autumn 1682 (?))</li>
<li>A Rule of Discovery (November 1682)</li>
<li>On the Use of the Combinatorial Art in the General Science (summer 1683)</li>
<li>Idea for a Book Whose Title Will Be <var>New Elements of Universal Mathesis</var> (summer 1683 (?))</li>
<li>On the Division of the Whole World of the Sciences (summer 1683 - autumn 1684 (?))</li>
<li>Introduction to a Secret Encyclopaedia (summer 1683 - autumn 1684 (?))</li>
<li>Short Definition of General Science (summer 1683 - summer 1684 (?))</li>
<li>On Universal Synthesis and Analysis, or the Art of Discovery and Judgement (summer 1683 - autumn 1684 (?))</li>
<li>General Observations (summer 1683 - beginning of 1685 (?))</li>
<li>Division of Terms and Enumeration of Attributes (summer 1683 - beginning of 1685 (?))</li>
<li>Genera of Terms (summer 1683 - beginning of 1685 (?))</li>
<li>Divisions (summer 1683 - winter 1685/1686 (?))</li>
<li>A Popular Method of Teaching, and a More Perfect Scientific One (second half of 1683 - winter 1685/1686 (?))</li>
<li>On the True Perfection of Humankind (spring 1684 - beginning of 1685 (?))</li>
<li>Plus Ultra (spring 1684 - end 1685 (?))</li>
<li>Definitions of Metaphysical and Logical Notions (mid-1685 (?))</li>
<li>New Proposals (summer-autumn 1685 (?))</li>
<li>Recommendations for Founding the General Science (summer-autumn 1685 (?))</li>
<li>On the Obscuring of Primary Propositions (summer 1685 - October 1690 (?))</li>
<li>The Elements of Universal Truth (summer 1685 - October 1690 (?))</li>
<li>For the Preface to <var>The Elements of Eternal Truth</var> (summer 1685 - October 1690 (?))</li>
<li>The Elements of Reason (1686 (?))</li></ol>

                  Bibliography<br /><br />
                  Index
                  <br></br><br></br>
                  {isMobile ? (
                    <div id="endorsements">
                      <hr></hr><p style={{paddingTop: '10px'}}>Go back to the top of the page <span style={{color: 'blue'}} onClick={() => scrollToElement('top')}>here</span></p>
                      {endorsements()}
                    </div>
                  ) : (
                    <>
                    </>
                  )}
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default LeibnizOnBinary;
